import 'core-js/modules/es6.object.keys.js';
import { Months } from './common/months.js';

var DISABLED_MODIFIER = "disabled";
var HOVERED_RANGE_MODIFIER = "hovered-range";
var OUTSIDE_MODIFIER = "outside";
var SELECTED_MODIFIER = "selected";
var SELECTED_RANGE_MODIFIER = "selected-range"; // modifiers the user can't set because they are used by Blueprint or react-day-picker

var DISALLOWED_MODIFIERS = [DISABLED_MODIFIER, HOVERED_RANGE_MODIFIER, OUTSIDE_MODIFIER, SELECTED_MODIFIER, SELECTED_RANGE_MODIFIER];
function getDefaultMaxDate() {
  var date = new Date();
  date.setFullYear(date.getFullYear());
  date.setMonth(Months.DECEMBER, 31);
  return date;
}
function getDefaultMinDate() {
  var date = new Date();
  date.setFullYear(date.getFullYear() - 20);
  date.setMonth(Months.JANUARY, 1);
  return date;
}
function combineModifiers(baseModifiers, userModifiers) {
  var modifiers = baseModifiers;

  if (userModifiers != null) {
    modifiers = {};

    for (var _i = 0, _Object$keys = Object.keys(userModifiers); _i < _Object$keys.length; _i++) {
      var key = _Object$keys[_i];

      if (DISALLOWED_MODIFIERS.indexOf(key) === -1) {
        modifiers[key] = userModifiers[key];
      }
    }

    for (var _i2 = 0, _Object$keys2 = Object.keys(baseModifiers); _i2 < _Object$keys2.length; _i2++) {
      var _key = _Object$keys2[_i2];
      modifiers[_key] = baseModifiers[_key];
    }
  }

  return modifiers;
}

export { DISABLED_MODIFIER, DISALLOWED_MODIFIERS, HOVERED_RANGE_MODIFIER, OUTSIDE_MODIFIER, SELECTED_MODIFIER, SELECTED_RANGE_MODIFIER, combineModifiers, getDefaultMaxDate, getDefaultMinDate };
//# sourceMappingURL=datePickerCore.js.map
